import React from "react"
import 'aos/dist/aos.css';
import Typed from 'typed.js';

import FormCard from "./FormCard"
import ChecklistItem from "./ChecklistItem";

export class About extends React.Component {
  
    componentDidMount () {
      console.log('hello')
      var options = {
        strings: ["Finance", "Real Estate", "Retail", "AI Training", "IP Protection"],
        typeSpeed: 40,
        backSpeed: 30,
        loop: true
      };
      new Typed('.typedelement', options);
    }
    
    render() {
    return (
    <section id="contact_us" class="pt-8 pt-md-11 bg-gradient-light">
      <div class="container">
        <div class="row align-items-center justify-content-between mb-8 mb-md-11">
          <div class="col-12 col-md-6 order-md-2" data-aos="fade-left">
            
            {/* Heading */}
            <h2>
              Business Solutions<br/>
              <span class="text-success">for <span class="typedelement"></span></span>
            </h2>

            {/* Text */}
            <p class="font-size-lg text-muted mb-6">
                No matter if you're tracking property prices, training AI models, building dashboards, modeling the stock market, analyzing competition or protecting your IP.
                <br/><br/>
                We help businesses collect hard-to-get, high-quality data from the web and turn it into clean, structured insights you can actually use.
                Whatever you see on the web can be collected at industrial scale and any action online automated.
            </p>

            {/* Checklist */}
            <div class="row">
              <div class="col-12 col-lg-6">
                <ChecklistItem text="Maximize Efficiency"/>
                <ChecklistItem text="Gather Insights"/>
                <ChecklistItem text="Increase Revenue"/>
              </div>
              <div class="col-12 col-lg-6 mb-6 mb-md-0">
              </div>
            </div> {/* / .row */}

          </div>
          <div class="col-12 col-md-6 col-lg-5 order-md-1" data-aos="fade-right"> 
            <FormCard/>
          </div>

        </div> {/* / .row */}
        </div> 
    </section>
    )}
}

export default About
